// extracted by mini-css-extract-plugin
export default {"contentInnerContainer":"tenant-edit_contentInnerContainer__UOfcK","item":"tenant-edit_item__cZ5qx"};